(ns manage.column-classification-table.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Stack$default" :as Stack]
            [common.flags :refer [use-flag]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.table :as t]
            [manage.content-variant-ocp.db.column-classification :as form]
            [reagent.core :as r]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui format-classification
  [{:keys [field-name]}]
  (let [content-optimizing-enabled? (use-flag :content-variant-content-optimizing)]
    ($ form-field
       {:err-msg (form/use-error-message [:raw-classification field-name])
        :sx #js {:flex 1}}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:raw-classification field-name])
                         {:options (form/get-filtered-classification-options content-optimizing-enabled?)
                          :clearable? true})]))))

(def columns
  [{:id :name-type
    :label "Fieldname"
    :format identity}
   {:id :classification
    :label "Classification"
    :format #($ format-classification {:field-name %})}])

(defui cell
  [{:keys [id format field-name]}]
  (r/as-element
   [t/table-cell
    {:key id
     :data-testid (str "table-column-classification__column--" (name id))}
    (format field-name)]))

(defui row
  [{:keys [field-name]}]
  (r/as-element
   [t/table-row {:data-testid :table-column-classification-data-row
                 :style {:min-height "7rem"}}
    (for [{:keys [id format]} columns]
      ($ cell {:key id
               :id field-name
               :format format
               :field-name field-name}))]))

(defui table
  []
  (let [{:keys [state value]} (use-subscribe [:table.column-classification/value])
        search (use-subscribe [:table.column-classification/search-term])
        error (use-subscribe [:form.content-variant.column-classification/error [:raw-classification]])]
    ($ :<>
       ($ Stack {:sx #js {:px 3}}
          (when (:identifier-key error)
            ($ Alert {:severity "warning"}
               "You didn't classify any of your columns as a unique identifier,
                please select `Identifier` for one of the columns below."))
          (when (:youtube-description-key error)
            ($ Alert {:severity "warning"}
               "Your adset targets YouTube. You must classify one of the columns as the `YouTube Description`."))
          (when (:click-through-key error)
            ($ Alert {:severity "warning"}
               "You didn't classify any of your columns as a click through,
                please select `Click through` for one of the columns below.")))
       (r/as-element
        [t/table {:data-testid :table-feed-mapping}
         [t/table-row {}
          (for [{:keys [id label]} columns]
            ^{:key id} [t/table-head label])]
         (cond
           (= :failure state) [t/table-message "We could not load any classification data, please provide a valid sheet in the previous step."]
           (= :pending state) [t/table-message "Loading fields"]
           (and (not-empty search)
                (empty? value)) [t/table-message "No fields found for this term"]
           (empty? value) [t/table-message "We could not load any classification data, please provide a valid sheet in the previous step."]
           (= :success state)
           (for [field-name value]
             ($ row {:key field-name :field-name field-name})))]))))
